/* tslint:disable */
/* eslint-disable */
import { MilestoneDisplayModel as AceXFoundPortalCoreCaqModelsMilestoneDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/milestone-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { MilestoneDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsMilestoneDisplayModelFormGroup } from '@/api/model-index';

export interface IScheduleDisplayModel {
  milestones?: null | Array<AceXFoundPortalCoreCaqModelsMilestoneDisplayModel>;
}
export class ScheduleDisplayModel extends BaseModel implements IScheduleDisplayModel {
  milestones?: null | Array<AceXFoundPortalCoreCaqModelsMilestoneDisplayModel>;
}
class BaseScheduleDisplayModelFormGroup extends FormGroup {
  private static _instance: ScheduleDisplayModelFormGroup;
  
  public static get Instance(): ScheduleDisplayModelFormGroup {
    this._instance = new ScheduleDisplayModelFormGroup({
      milestones: new FormArray([]),
    });

    return this._instance;
  }
}


export class ScheduleDisplayModelFormGroup extends BaseScheduleDisplayModelFormGroup {
  public get Milestones(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsMilestoneDisplayModelFormGroup> {
    return this.controls["milestones"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsMilestoneDisplayModelFormGroup>;
  }
  

}

export module ScheduleDisplayModelForm
  {
    export class FormFields
    {
      static _milestones: string = "milestones";
    }
  }

